<template>
  <v-app-bar app height="70">
    <div class="w-full flex justify-between px-5">
      <div
        class="flex justify-center items-center relative duration-500 ease-in-out"
      >
        <img
          src="../assets/images/logo-sinisajax.png"
          alt="logo"
          loading="lazy"
          @click="$router.push('/')"
          class="h-12 w-auto cursor-pointer"
        />
      </div>
      <div class="flex items-center gap-3">
        <p
          class="text-red-600 text-sm font-medium cursor-pointer"
          @click="$router.push('/infokontraktor')"
        >
          Info Kontraktor
        </p>
        <p
          class="text-red-600 text-sm font-medium cursor-pointer"
          @click="$router.push('/penghargaan')"
        >
          Penghargaan
        </p>
        <p
          class="text-red-600 text-sm font-medium cursor-pointer"
          @click="$router.push('/tentangbib')"
        >
          Tentang BIB
        </p>
        <template v-if="userData != null">
          <v-menu
            v-model="notifMenuOpen"
            :close-on-content-click="false"
            @update:model-value="onNotifMenuUpdate"
          >
            <template v-slot:activator="{ props }">
              <div @click="getNotif(true)" v-bind="props">
                <v-badge
                  v-if="totalData > 0"
                  color="error"
                  :content="totalData"
                  class="cursor-pointer"
                >
                  <v-icon>mdi-bell</v-icon>
                </v-badge>
                <v-icon v-else class="-mt-2"> mdi-bell </v-icon>
              </div>
            </template>
            <v-card
              :loading="loading"
              class="w-72 shadow-lg rounded-md overflow-hidden"
            >
              <v-list v-if="notifications.length > 0">
                <v-list-item
                  v-for="(notif, index) in notifications"
                  :key="index"
                  class="hover:bg-slate-100"
                >
                  <div class="flex items-start gap-3 w-full">
                    <font-awesome-icon
                      icon="fa-solid fa-circle-exclamation"
                      class="text-yellow-500 mt-1"
                    />
                    <div class="flex gap-2 items-start justify-between w-full">
                      <a
                        class="cursor-pointer text-xs"
                        @click="redirectToDetail(notif)"
                        v-html="notif.message"
                      ></a>
                      <v-menu v-if="notif.type == '002' || notif.evaluasiPjp">
                        <template v-slot:activator="{ props }">
                          <i
                            class="mdi mdi-dots-vertical text-sm cursor-pointer"
                            v-bind="props"
                          ></i>
                        </template>
                        <div
                          class="bg-white cursor-pointer px-3 py-2 rounded-md shadow-lg border hover:bg-slate-100"
                          @click.stop="markAsRead(notif)"
                        >
                          <p class="text-xs font-medium">
                            <i class="mdi mdi-check"></i>
                            Mark as Read
                          </p>
                        </div>
                      </v-menu>
                    </div>
                  </div>
                </v-list-item>
                <v-list-item>
                  <div
                    class="flex justify-center items-center gap-5 text-xs font-semibold border-t w-full pt-4"
                  >
                    <div
                      class="flex gap-2 cursor-pointer"
                      @click.stop="currentPage != 1 ? changePage(-1) : ''"
                      :class="{
                        'cursor-not-allowed opacity-50': currentPage == 1,
                      }"
                    >
                      <i class="mdi mdi-arrow-left list-none"> </i>
                      <h6>Back</h6>
                    </div>
                    <div
                      class="flex gap-2 cursor-pointer"
                      @click.stop="
                        notifications.length == perPage ? changePage(1) : ''
                      "
                      :class="{
                        'cursor-not-allowed opacity-50':
                          notifications.length != perPage,
                      }"
                    >
                      <h6>Next</h6>
                      <i class="mdi mdi-arrow-right"> </i>
                    </div>
                  </div>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item>
                  <v-list-item-title class="text-center">
                    Tidak ada notifikasi
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          <div class="h-full w-[1px] bg-slate-400 mx-5"></div>
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ props }">
              <div
                v-bind="props"
                class="flex items-center gap-5 cursor-pointer"
                @click="refreshUserData"
              >
                <div class="flex justify-start items-center gap-3">
                  <img
                    :src="url_photo"
                    alt="avatar"
                    class="w-8 h-8 object-cover rounded-full"
                    loading="lazy"
                    @error="($event) => ($event.target.src = defaultAvatar)"
                  />
                  <div>
                    <span class="text-sm font-semibold text-slate-700">
                      {{
                        Array.isArray(userData.role)
                          ? userData.role[0]
                          : userData.inisial
                      }}
                    </span>
                    <h6
                      class="text-slate-700 text-[10px] font-semibold"
                      v-if="userData.isPjo"
                    >
                      {{ userData.isPjo ? "PJO" : "" }}
                    </h6>
                  </div>
                </div>
                <img
                  src="../assets/icons/arrow.png"
                  alt="arrow"
                  class="h-3 w-auto rotate-90"
                />
              </div>
            </template>
            <v-card class="min-w-72 shadow-lg rounded-md overflow-hidden">
              <div class="flex items-center gap-3 border-b py-3 px-3">
                <div
                  class="w-10 h-10 rounded-full bg-gray-400 overflow-hidden shrink-0"
                >
                  <img
                    :src="url_photo"
                    alt="icon"
                    loading="lazy"
                    class="w-full h-full object-cover"
                    @error="($event) => ($event.target.src = defaultAvatar)"
                  />
                </div>
                <div class="flex flex-col">
                  <p class="text-xs font-semibold text-slate-700">
                    {{ userData.name }}
                  </p>
                  <p class="text-[10px] text-gray-400">
                    {{ userData.email }}
                  </p>
                </div>
              </div>
              <div class="px-3 pb-3">
                <div v-if="userData.isafe_no">
                  <label for="" class="text-[10px] text-gray-400">
                    iSafe No
                  </label>
                  <p class="text-sm font-semibold text-stone-700 -mt-1">
                    {{ userData.isafe_no || "-" }}
                  </p>
                </div>
                <div v-if="userData.kontraktorName">
                  <label for="" class="text-[10px] text-gray-400">
                    Perusahaan
                  </label>
                  <p class="text-sm font-semibold text-stone-700 -mt-1">
                    {{ userData.kontraktorName || "-" }}
                  </p>
                </div>
                <div v-if="userData.department">
                  <label for="" class="text-[10px] text-gray-400">
                    Departemen
                  </label>
                  <p class="text-sm font-semibold text-stone-700 -mt-1">
                    {{ userData.department || "-" }}
                  </p>
                </div>
                <div v-if="workAreaDisplay">
                  <label for="" class="text-[10px] text-gray-400">
                    Area Kerja
                  </label>
                  <p class="text-sm font-semibold text-stone-700 -mt-1">
                    {{ workAreaDisplay }}
                  </p>
                </div>

                <FormButton
                  label="Logout"
                  variant="outlined"
                  class="w-full mt-3"
                  @click="doLogout"
                  id="navbar_action_click_logout"
                >
                  <template v-slot:prepend>
                    <i class="mdi mdi-logout"></i>
                  </template>
                </FormButton>
              </div>
            </v-card>
          </v-menu>
        </template>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { API_BASE_URL, CLIENT_ID, CMS_SSE_STREAM } from "@/constants";
import GlobalDataMixin from "@/GlobalDataMixin";
import axios from "axios";
import Swal from "sweetalert2";
import util from "@/assets/js/util";
import { NotificationService } from "@/services/notification-service";
import { levelEnum } from "@/utilities/enum";
import FormButton from "@/components/FormButton.vue";
import { previewPhoto, refreshUserData } from "@/utilities/globalFunction";
import { EvaluationPJPService } from "@/services/evaluation_pjp-service";
const url_sse_stream = API_BASE_URL + CMS_SSE_STREAM;

export default {
  mixins: [GlobalDataMixin],
  components: {
    FormButton,
  },
  name: "NavbarLayout",
  computed: {
    workAreaDisplay() {
      const raw = this.userData?.workArea;
      if (!raw || typeof raw !== "string") return "";
      try {
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.join(", ") : String(arr);
      } catch {
        const stripped = raw.replace(/^\[|\]$/g, "").trim();
        return stripped
          ? stripped
              .split(",")
              .map((s) => s.trim())
              .join(", ")
          : "";
      }
    },
  },
  data() {
    return {
      loading: false,
      notifMenuOpen: false,
      skipNotifMenuClose: false,
      currentPage: 1,
      perPage: 10,
      totalData: 0,
      notifications: [],
      role: null,
      url_photo: null,
      levelEnum,
      photoCacheBuster: Date.now(),
      defaultAvatar: require("@/assets/icon/profile.png"),
    };
  },
  mounted() {
    if (this.userData != null) {
      // Append cache-busting query param to prevent browser from serving stale photo
      // Works for both admin (role is array) and kontraktor (role is string) users
      this.url_photo =
        this.userData?.id != null && this.userData?.id?.toString() !== ""
          ? previewPhoto(this.userData.id) + "&t=" + this.photoCacheBuster
          : this.defaultAvatar;
      this.role = this.resolveUserRole(this.userData.role);

      const role = Array.isArray(this.userData.role)
        ? "isafe"
        : this.userData.role;

      this.getNotif(false);

      // Fetch fresh user data on mount
      this.refreshUserData();

      const eventSource = new EventSource(
        url_sse_stream +
          "?token=" +
          this.userData.token +
          "&role=" +
          role +
          "&email=" +
          this.userData.email,
      );
      eventSource.onmessage = (event) => {
        // console.log("event.data = ", JSON.parse(event.data));
        let dt = JSON.parse(event.data);
        if (dt.role == "admin" && role == "isafe") {
          this.getNotif(false);
        }

        if (
          dt.role == "kontraktor" &&
          role == "kontraktor" &&
          dt.id == this.userData.kontraktorID
        ) {
          this.getNotif(false);
        }
      };
    }
  },
  methods: {
    // Fetch latest user data from backend and update component state + photo URL
    async refreshUserData() {
      try {
        const updated = await refreshUserData(this.userData);
        this.userData = updated;
        // Reset cache-buster so the photo URL changes and browser fetches fresh image
        this.photoCacheBuster = Date.now();
        if (this.userData.id != null && this.userData.id.toString() !== "") {
          this.url_photo =
            previewPhoto(this.userData.id) +
            "&t=" +
            this.photoCacheBuster;
        }
      } catch (err) {
        console.error("[NavbarLayout] Failed to refresh user data:", err);
      }
    },
    onNotifMenuUpdate(isOpen) {
      if (!isOpen) {
        if (this.skipNotifMenuClose) {
          this.skipNotifMenuClose = false;
          this.$nextTick(() => (this.notifMenuOpen = true));
        } else {
          this.currentPage = 1;
        }
      }
    },
    async getNotif(list = false) {
      const role = (this.userData.role || []).includes("ADMIN")
        ? "admin"
        : this.userData.role === levelEnum.KONTRAKTOR
        ? "kontraktor"
        : undefined;
      const id = !Array.isArray(this.userData.role)
        ? this.userData.kontraktorID
        : undefined;

      const email = this.userData.email;

      try {
        this.loading = true;
        const response = await NotificationService.list({
          usecase: list ? "list" : "count",
          role: role,
          userId: this.userData.userId,
          id: id,
          page: list ? this.currentPage : undefined,
          perPage: list ? this.perPage : undefined,
          isafeno: email,
        });

        if (list) {
          const data = response.data;

          for (const item of data) {
            if (item.type == "modification-kontraktor") {
              item.message = item.message.replace(
                /Kontraktor\s([A-Z\s]+)/,
                (match, p1) =>
                  `Kontraktor <b class="text-red-600 font-medium">${p1.trim()}</b> `,
              );
            } else if (item.type == "imkp-kontraktor") {
              item.message = item.message.replace(
                /Kepada mitra\s([A-Z\s]+)/,
                (match, p1) =>
                  `Kepada mitra <b class="text-red-600 font-medium">${p1.trim()}</b> `,
              );
            } else if (["001", "002", "003"].includes(item.type)) {
              item.message = item.message.replace(
                /\b([A-Za-z0-9]+(?:-[A-Za-z0-9]+)+)\b/g,
                `<b class="text-red-600 font-medium">$1</b>`,
              );
            }
          }
          this.notifications = data;
        } else {
          this.totalData = response.count;
        }
      } catch (error) {
        console.log("error", error);
        util.showError("Failed get notification");
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async redirectToDetail(notif) {
      this.notifMenuOpen = false;
      if (notif.type == "modification-kontraktor") {
        if (this.role == levelEnum.KONTRAKTOR) {
          this.$router.push({ path: `/profile` });
        } else {
          this.$router.push({ path: `/profileKontraktor/${notif.id}` });
        }
      } else if (notif.type == "imkp-kontraktor") {
        if (this.role == levelEnum.KONTRAKTOR) {
          this.$router.push({ path: `/imkp/${notif.path}` });
        } else {
          this.$router.push({ path: `/verifikasi-data-imkp/${notif.path}` });
        }
      } else if (["001", "002"].includes(notif.type)) {
        switch (notif.ncCategoryId) {
          case 1:
            this.$router.push({
              path: `/nc-smkp-report/${notif.ncDocumentId}`,
            });
            break;
          case 2:
            this.$router.push({
              path: `/nc-smkp-mitra-report/${notif.ncDocumentId}`,
            });
            break;
          case 3:
            this.$router.push({
              path: `/nc-audit-iso-smk3-internal/${notif.ncDocumentId}`,
            });
            break;
          case 4:
            this.$router.push({
              path: `/nc-audit-iso-smk3-external/${notif.ncDocumentId}`,
            });
            break;
          case 5:
            this.$router.push({
              path: `/evaluation-report/nc-pjp/${notif.ncDocumentId}`,
            });
            break;
          default:
            break;
        }
      } else if (["003"].includes(notif.type)) {
        switch (notif.ncCategoryId) {
          case 1:
            this.$router.push({
              path: `/nc-smkp-monitoring`,
              query: { tab: 2 },
            });
            break;
          case 2:
            if (this.role === levelEnum.KONTRAKTOR) {
              this.$router.push({
                path: `/nc-smkp-mitra-monitoring-mitra`,
                query: { tab: 2 },
              });
            } else {
              this.$router.push({
                path: `/nc-smkp-mitra-monitoring`,
                query: { tab: 2 },
              });
            }
            break;
          case 3:
            this.$router.push({
              path: `/nc-audit-iso-smk3-internal-monitoring`,
              query: { tab: 2 },
            });
            break;
          case 4:
            this.$router.push({
              path: `/nc-audit-iso-smk3-external-monitoring`,
              query: { tab: 2 },
            });
            break;
          case 5: {
            const document = await EvaluationPJPService.findById(
              notif.ncDocumentId,
            );

            const periodeParts = document?.data?.periode?.split(" - ") ?? [
              "",
              "",
            ];
            const year = periodeParts[1] ?? "";
            const period = periodeParts[0] ?? "";

            this.$router.push({
              path: `/evaluation-monitoring`,
              query: { tab: 2, year, periode: period },
            });
            break;
          }
          default:
            break;
        }
      } else if (notif.type == "coc-expired") {
        if (this.role == levelEnum.KONTRAKTOR) {
          this.$router.push({ path: "/sio" });
        } else {
          if (this.$route.path === "/dashboard") {
            this.openCocExpiredDialog();
          } else {
            this.$router.push({
              path: "/dashboard",
              query: { openCocExpiredDialog: "1" },
            });
          }
        }
      } else {
        let path = notif.path;
        if (/^https?:\/\//i.test(path)) {
          const url = new URL(path);
          path = `${url.pathname}${url.search}${url.hash}`;
        }
        this.$router.push({ path });
      }
    },
    openCocExpiredDialog() {
      if (document.querySelector("#lihatLainExpCoc")) {
        let button = document.createElement("a");
        button.setAttribute("data-bs-toggle", "modal");
        button.setAttribute("data-bs-target", "#lihatLainExpCoc");
        document.body.appendChild(button);
        button.click();
        button.remove();
      }
    },
    async markAsRead(notif) {
      this.skipNotifMenuClose = true;
      try {
        if (notif.evaluasiPjp) {
          await EvaluationPJPService.readNotifLog(notif.idNotification);
        } else {
          await NotificationService.markAsRead(notif.idNotification);
        }
      } catch (error) {
        console.log("error", error);
        util.showError("Failed mark as read");
        this.skipNotifMenuClose = false;
      } finally {
        this.currentPage = 1;
        await this.getNotif(false);
        await this.getNotif(true);
        this.$nextTick(() => {
          setTimeout(() => (this.skipNotifMenuClose = false), 150);
        });
      }
    },
    changePage(num) {
      let cp = this.currentPage + num;
      if (
        !(num == -1 && this.currentPage == 1) &&
        cp * this.perPage <= this.totalData + (this.perPage - 1)
      ) {
        this.currentPage = this.currentPage + num;
        this.getNotif(true);
      }
    },
    async logoutIam() {
      console.log("LOGOUT keycloak");
      try {
        const token = localStorage.getItem("ugems-accessToken");
        const refreshToken = localStorage.getItem("ugems-refreshToken");

        const payload = new URLSearchParams({
          client_id: CLIENT_ID,
          refresh_token: refreshToken,
        }).toString();

        // const payload =
        //   `client_id=${encodeURIComponent(CLIENT_ID)}` +
        //   `&refresh_token=${encodeURIComponent(refreshToken)}`;

        await axios.post(
          "https://iam.ugems.id/realms/ugems/protocol/openid-connect/logout",
          payload,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/x-www-form-urlencoded",
            },
          },
        );
      } catch (err) {
        console.log("ERRROR LOGOUT keycloak", err);
      }
    },
    async doLogout() {
      const result = await Swal.fire({
        title: "Apakah Anda yakin akan keluar ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
      });

      if (result.isConfirmed) {
        if (this.userData.iam) {
          await this.logoutIam();
        }
        localStorage.clear();
        await Swal.fire("Keluar!", "Anda berhasil keluar.", "success");
        window.location.reload();
      }
    },
  },
};
</script>

<style scoped>
:deep(.swal2-container) {
  all: unset !important;
}
</style>
